import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";

// Importing Modal
import ModalSection from "../../components/common/ModalSection";

class Section extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
    };
    // Ensure callModal is bound correctly
    this.callModal = this.callModal.bind(this);
  }

  callModal() {
    this.refs.child.openModal();
  }

  render() {
    return (
      <React.Fragment>
        <section className="section bg-home home-half" id="home">
          <div className="bg-overlay"></div>
          <Container>
            <Row>
              <Col
                lg={{ size: 8, offset: 2 }}
                className="text-white text-center"
              >
               <h4 className="home-small-title" style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)', fontSize: '4rem' }}>
                  <span className="text-uppercase">IPME</span>
                </h4>
                <h1 className="home-title" style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)', fontSize: '2rem' }}>
                Ingeniería, Proyectos y Mantenimiento Especializados
                </h1>
                <p className="pt-3 home-desc mx-auto" style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)' }}>
                  Servicio a plantas distribuidoras | Servicio a unidades de reparto de medio y alto flujo | Servicio de autoabastos
                </p>

                {/* <p className="play-shadow mt-4">
                  <Link
                    onClick={this.callModal}
                    to="#"
                    className="play-btn video-play-icon"
                  >
                    <i className="mdi mdi-play text-center"></i>
                  </Link>
                </p> */}
              </Col>
              {/* Render ModalSection Component for Modal */}
              {/* <ModalSection ref="child" channel="vimeo" videoId="99025203" /> */}
            </Row>
          </Container>
          <div className="wave-effect wave-anim">
            <div className="waves-shape shape-one">
              <div
                className="wave wave-one"
                style={{
                  backgroundImage: `url(assets/images/wave-shape/wave1.png)`,
                }}
              ></div>
            </div>
            <div className="waves-shape shape-two">
              <div
                className="wave wave-two"
                style={{
                  backgroundImage: `url(assets/images/wave-shape/wave2.png)`,
                }}
              ></div>
            </div>
            <div className="waves-shape shape-three">
              <div
                className="wave wave-three"
                style={{
                  backgroundImage: `url(assets/images/wave-shape/wave3.png)`,
                }}
              ></div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default Section;
